import { IndicatorData } from '../TechnicalAnalysisTradingView';

export interface OhlcRow {
  time: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume?: number;
}

export function calculateRSI(data: OhlcRow[], period: number): IndicatorData[] {
  const result: IndicatorData[] = [];
  if (!data || data.length < period + 1 || period <= 0) return result;

  let sumGain = 0;
  let sumLoss = 0;

  // Initial sum for the first 'period' changes
  for (let i = 1; i <= period; i++) {
    const change = (data[i]?.close ?? 0) - (data[i - 1]?.close ?? 0);
    if (change > 0) sumGain += change;
    else sumLoss += Math.abs(change);
  }

  let avgGain = sumGain / period;
  let avgLoss = sumLoss / period;

  const pushResult = (time: number, gain: number, loss: number) => {
    if (loss === 0) {
      result.push({ time, value: 100 });
    } else {
      const rs = gain / loss;
      result.push({ time, value: 100 - (100 / (1 + rs)) });
    }
  };

  pushResult(data[period]?.time ?? 0, avgGain, avgLoss);

  // Wilder's smoothing for subsequent data points
  for (let i = period + 1; i < data.length; i++) {
    const change = (data[i]?.close ?? 0) - (data[i - 1]?.close ?? 0);
    const gain = change > 0 ? change : 0;
    const loss = change < 0 ? Math.abs(change) : 0;

    avgGain = (avgGain * (period - 1) + gain) / period;
    avgLoss = (avgLoss * (period - 1) + loss) / period;

    pushResult(data[i]?.time ?? 0, avgGain, avgLoss);
  }

  return result;
}
